import { render } from "./SocialPostPreview.vue?vue&type=template&id=5b464d7a&scoped=true&ts=true"
import script from "./SocialPostPreview.vue?vue&type=script&lang=ts"
export * from "./SocialPostPreview.vue?vue&type=script&lang=ts"

import "./SocialPostPreview.vue?vue&type=style&index=0&id=5b464d7a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b464d7a"]])

export default __exports__